import { render, staticRenderFns } from "./PagamentoComplementoInformacoes.vue?vue&type=template&id=655a6e7e&"
import script from "./PagamentoComplementoInformacoes.vue?vue&type=script&lang=js&"
export * from "./PagamentoComplementoInformacoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VExpansionPanel,VExpansionPanelContent,VExpansionPanelHeader,VForm})
